import React, { Component } from "react";

import { markdownify } from "config/utils";

import Icon from "components/Icon";
import VideoModal from "components/VideoModal";

import {
  Image,
  Title,
  Heading,
  Content,
  Block,
  Preview,
  PlayButton
} from "./styles";

import { BlockWrapper } from "components/Block";

class ContentVideoBlock extends Component {
  state = {
    modalVisible: false
  };

  toggleModalVisibility = () => {
    this.setState(state => ({ modalVisible: !state.modalVisible }));
  };

  render() {
    const { modalVisible } = this.state;
    const { content, ...props } = this.props;

    return (
      <>
        <BlockWrapper alignItems="center" {...props}>
          <Block width={["100%", "100%", "50%"]} order={["2", "2", "1"]}>
            {content.title && <Title>{content.title}</Title>}
            <Heading>{content.heading}</Heading>
            <Content
              dangerouslySetInnerHTML={{ __html: markdownify(content.text) }}
            />
          </Block>
          <Block width={["100%", "100%", "50%"]} order={["0", "0", "2"]}>
            <Preview>
              <Image content={content.image} />
              <PlayButton onClick={this.toggleModalVisibility} shade="primary">
                <Icon icon="play" color="white" size="35px" />
              </PlayButton>
            </Preview>
          </Block>
        </BlockWrapper>
        {modalVisible && (
          <VideoModal
            videoId={content.youtubeId}
            toggleVisibility={this.toggleModalVisibility}
          />
        )}
      </>
    );
  }
}

export default ContentVideoBlock;
